export var GraphCommand;
(function (GraphCommand) {
    GraphCommand["bar"] = "bar";
    GraphCommand["graph"] = "graph";
    GraphCommand["graph3d"] = "3d";
    GraphCommand["levels"] = "levels";
    GraphCommand["cuts"] = "cuts";
    GraphCommand["timegraph"] = "timegraph";
})(GraphCommand || (GraphCommand = {}));
export var GraphType;
(function (GraphType) {
    GraphType["Normal"] = "Normal";
    GraphType["Polar"] = "Polar";
})(GraphType || (GraphType = {}));
export var FolderType;
(function (FolderType) {
    FolderType["Defined"] = "defined";
    FolderType["Custom"] = "custom";
})(FolderType || (FolderType = {}));
{
}
//# sourceMappingURL=config.js.map